import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  width: 434px;
`;

export const TopContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

type BottonContentProps = {
  gap: number;
};

export const BottomContent = styled.div<BottonContentProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ gap }) => gap}px;
  width: 100%;
`;
